import React from "react";
import StationInput from "components/StationInput";
import SwapInputsIcon from "components/icons/SwapInputsIcon";
import t from "lib/i18n";
import useGTM, {useGTMChange} from "hooks/useGTM";
import {trackStationFrom, trackStationTo, trackStationsSwap} from "lib/tracking";
import "styles/components/station-selector.scss";
import { TICKET_TYPES } from "consts";

const StationsSelector = props => {
  const dispatchGTM = useGTM();
  const swapStations = () => {
    dispatchGTM(trackStationsSwap());
    const stationTo = props.getValues("stationTo") ?? null;
    props.setValue("stationTo", props.getValues("stationFrom"), true);
    props.setValue("stationFrom", stationTo, true);
  };

  // Watch for the form's stations variable so it gets re-rendered when a user swaps the stations
  // or selection from StationLoction component
  props.watch(["stationFrom", "stationTo", "ticketSearchType", "mockStationsList"]);

  useGTMChange(props.getValues("stationFrom"), trackStationFrom);
  useGTMChange(props.getValues("stationTo"), trackStationTo);

  return (
    <div className="otrl-jp__station-selector">
      <StationInput
        className="otrl-jp__station-selector__from"
        aria-label={t("station.from.aria")}
        name="stationFrom"
        placeholder={t("station.from.placeholder")}
        value={props.getValues("stationFrom")}
        {...props}
      />
      {!props.hideStationTo && (
        <React.Fragment>
          <div className="otrl-jp__station-selector__swap otrl-jp__button-unstyled">
            <SwapInputsIcon onClick={swapStations} ariaLabel="Swap stations"/>
          </div>
          <StationInput
            className="otrl-jp__station-selector__to"
            aria-label={t("station.to.aria")}
            name="stationTo"
            location={false}
            placeholder={t("station.to.placeholder")}
            value={props.getValues("stationTo")}
            ticketSearchType={props.ticketType === TICKET_TYPES.SEASON ? "SeasonDestination" : "Destination"}
            {...props}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default StationsSelector;
